import { Box, IconButton, Modal, Typography } from "@mui/material"

import { EyeOutlined } from "@ant-design/icons"
import CloseIcon from "@mui/icons-material/Close"
import React, { useEffect, useState } from "react"
// import { signinMode } from "src/store/states/ckyc"
// import { downloadUrl } from "src/apis/signup"
import { useSetRecoilState } from "recoil"
import { downloadUrl } from "../../services/httpCalls"
// import { showLoader } from "src/store/states/isLoading"
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "700px",
  height: "700px",
  bgcolor: "background.paper",
  borderRadius: "5px",
  boxShadow: 24,
  p: 2
}
function PreviewDocsModalProbe(url) {
  const [open, setOpen] = React.useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [link, setLink] = useState(url?.url)
  //   const setShowLoader = useSetRecoilState(showLoader)
  const [showLoader, setShowLoader] = useState(false)


  useEffect(() => {
    // if (signinMode) {
    setShowLoader(true)
    let orgId = localStorage.getItem("orgId")
    if (url.url && open){
      try {
        downloadUrl(orgId, url.url)
          .then(res => {
            setLink(res.preSignedUrl)
            setShowLoader(false)
          })
          .finally(() => {
            setShowLoader(false)
          })
      } catch {
        setShowLoader(false)
      }
    }
  }, [url, open])

  return (
    <Box>
      <IconButton onClick={handleOpen}>
        <EyeOutlined
          style={{
            color: "#2862FF"
          }}
        />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box
            sx={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "space-between"
            }}
          >
            <Typography
              sx={{
                marginLeft: "10px",
                fontSize: "20px",
                // textTransform: "uppercase",
                fontWeight: "bold",
                marginBottom: "10px"
              }}
              component="h2"
            >
              Preview Files 1
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <iframe src={link} width="100%" height="600px"></iframe>
          </Box>
        </Box>
      </Modal>
    </Box>
  )
}

export default PreviewDocsModalProbe
